// Prev and Next, at the foot of the node being read — see
// docs/plan/260913_graph_reading_navigation.md.
//
// Prev is memory: it replays the trail. Next is judgement: it asks the server
// what to read now, which needs the whole graph, the reading history and the
// votes. They are not two directions of one control.
import React from "react";

const BTN =
  "rounded-lg border border-slate-800 bg-slate-900/40 px-4 py-1.5 text-sm transition " +
  "enabled:hover:border-sky-500/40 enabled:hover:text-sky-300 disabled:opacity-40";

const MODE = {
  learn: { label: "new", className: "bg-sky-500/15 text-sky-300" },
  recall: { label: "review", className: "bg-amber-500/15 text-amber-300" },
};

// `className` is the block's own spacing. It sits at the foot of the node pane
// beside Delete, where the standalone top margin would be wrong.
export default function GraphNav({
  canGoBack,
  busy,
  reason,
  mode,
  onPrev,
  onNext,
  className = "mt-3",
  // Autoplay is a third control, not a variant of Next: it presses Next FOR
  // you, once the node has been read aloud.
  autoplay = false,
  onToggleAutoplay = null,
}) {
  const badge = mode ? MODE[mode] : null;
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" className={BTN} disabled={!canGoBack || busy} onClick={onPrev}>
          ← Prev
        </button>
        <button type="button" className={BTN} disabled={busy} onClick={onNext}>
          Next →
        </button>
        {onToggleAutoplay && (
          <button
            type="button"
            onClick={onToggleAutoplay}
            aria-pressed={autoplay}
            className={`rounded-lg border px-3 py-1.5 text-sm transition ${
              autoplay
                ? "border-sky-500/40 bg-sky-500/10 text-sky-300"
                : "border-slate-800 bg-slate-900/40 hover:border-sky-500/40 hover:text-sky-300"
            }`}
          >
            {autoplay ? "❚❚ Autoplay" : "▶ Autoplay"}
          </button>
        )}
        {badge && (
          <span className={`rounded-full px-2.5 py-0.5 text-[11px] ${badge.className}`}>
            {badge.label}
          </span>
        )}
      </div>
      {/* The reason always occupies its line, so nothing shifts when it fills. */}
      <p className="mt-2 min-h-[1.25rem] text-xs text-slate-500">{reason}</p>
    </div>
  );
}
